import React, { useRef, useEffect, useState, lazy, Suspense } from 'react';
import { listObjectsInBucket } from '../S3/s3';
//import { configureAWS, getS3Instance } from '../S3/s3'; //Old implementation
import AWS from 'aws-sdk';
// import "../../styles.css";
//import './styles.css';
import './Main.module.css';
import Preview from '../Preview/Preview';
import ModelViewer from '../ModelViewer/ModelViewer';
import ProductViewerComponent from '../Preview/React360Viewer';
import InnerImageZoom from '../InnerImageZoom/InnerImageZoom';
import { Spinner } from 'spin.js';
import './spin.css';

// const Preview = lazy(() => import('../Preview/Preview'));
// const ModelViewer = lazy(() => import('../ModelViewer/ModelViewer'));
// const ProductViewerComponent = lazy(() => import('../Preview/React360Viewer'));
// const InnerImageZoom = lazy(() => import('../InnerImageZoom/InnerImageZoom'));

const PointOfView = {
  Front: 'front',
  Left: 'left',
  Back: 'back',
  Right: 'right',
}

const SelectedViewer = {
  ThreeSixty: 'ThreeSixtyViewer',
  ThreeD: 'ModelViewer',
  TwoD: 'Lifestyle',
}

const ObjectType = {
  Image: 'image',
  ModelGlb: 'modelGlb',
  ModelGlbU: 'modelGlbU',
  ModelUsd: 'modelUsd',
  ModelHdr: 'modelHdr',
  EnvironmentHdr: 'environmentHdr',
}

const productImageTemplate = {
  image: null,
  thumbnail: null,
}

const cameraTransform = {
  location: null,
  rotation: null,
}

const Main = (props) => {
  const [currentIdx, setCurrentIdx] = useState(0);
  const [modelviewerSelected, setModelviewerSelected] = useState(SelectedViewer.ThreeSixty);
  const [modelViewerInitialised, setModelViewerInitialised] = useState(false);
  const [isAutoPlay, setIsAutoplay] = useState(true);
  const [imageToShow, setImageToShow] = useState(0);
  const [toggleImage, setToggleImage] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [yawAngle, setYawAngle] = useState(15);
  const [pitchAngle, setPitchAngle] = useState(75);
  const [picToShow, setPicToShow] = useState(null);
  const [images360, setImages360] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const [modelGlb, setModelGlb] = useState();
  //Uncompressed Glb model
  const [modelGlbU, setModelGlbU] = useState();
  const [modelUsd, setModelUsd] = useState();
  const [modelHdrs, setModelHdrs] = useState();
  const [environmentHdrs, setEnvironmentHdrs] = useState();
  const [productSettings, setProductSettings] = useState(JSON.parse(props.productSettings));
  const [objectDimensions, setObjectDimensions] = useState();
  const [isFilesLoaded, setIsFilesLoaded] = useState(false);
  const [isButtonsReady, setIsButtonsReady] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  //TODO: Swap fixed values for parameters
  const [buttonsDivSize, setButtonsDivSize] = useState(Math.min((window.innerWidth - 40), 1000) / 1000 * 200);
  const [aspectRatio360, setAspectRatio360] = useState(1);
  const [aspectRatioProduct, setAspectRatioProduct] = useState(1);
  const [aspectRatioTop, setAspectRatioTop] = useState(1);
  const [isShow360SpinIcon, setIsShow360SpinIcon] = useState(false);
  //Get a ref to out mainProductViewer container so we can set the width of children based on its width
  const mainProductViewerRef = useRef(null);
  //We need to set those values on instantiation
  const [mainProductViewerWidth, setMainProductViewerWidth] = useState(0);
  const [mainProductViewerHeight, setMainProductViewerHeight] = useState(0);
  const [camTransform, setCamTransform] = useState({ ...cameraTransform });
  const triggerAREvent = useRef(null);
  const [isAspectRatio360Calculated, setIsAspectRatio360Calculated] = useState(false);
  const [isAspectRatioTopCalculated, setIsAspectRatioTopCalculated] = useState(false);
  const [isAspectRatioProductCalculated, setIsAspectRatioProductCalculated] = useState(false);
  const [is360Present, setIs360Present] = useState(false);
  const [isTopPresent, setIsTopPresent] = useState(false);
  const [isProductPresent, setIsProductPresent] = useState(false);
  const [viewpointImages, setViewpointImages] = useState({
    [PointOfView.Front]: "",
    [PointOfView.Left]: "",
    [PointOfView.Back]: "",
    [PointOfView.Right]: "",
  });
  const [windowMargin, setWindowMargin] = useState(10);
  const [viewerMarginLeft, setViewerMarginLeft] = useState(0);
  const [widthSwitchToFullScreen, setWidthSwitchToFullScreen] = useState(980);
  const [maxViewerWidth, setMaxViewerWidth] = useState(1100);
  const [viewerMargin, setViewerMargin] = useState(30);
  const [modelViewerMargin, setModelViewerMargin]  = useState(25);
  const mobileWidthThreshold = 540;
  const [variantDataMap, setVariantDataMap] = useState(new Map());
  const [viewerSize, setViewerSize] = useState({ width: 0, height: 0 });
  //const s3Ref = useRef(new AWS.S3());
  const spinnerContainerRef = useRef(null); // Create a reference for the spinner container
  const spinnerInstanceRef = useRef(null); // Store the Spinner instance
  const dataRef = useRef(null);
  const imagesBaseUrl = `https://${props.productsS3Bucketname}.s3.eu-west-2.amazonaws.com/${props.productFolder}/`;
  const bucketName = props.productS3BucketUrl;
  const prefix = props.productFolder;
  const baseCloudFrontUrl = props.cloudFrontUrl;
  const buttonHeightSpace = 180;
  const viewerBtnShrinkRatio = 0.8;
  const additionalButtonsMaxSize = 200;
  const timeBeforeShowingSpinIcon = 2500;

  //TODO: Parse whole directory and extract model and images
  // const customerFiles = Array.from(props.productS3BucketUrl);
  //const model = customerFiles.filter(item => item.Key.match(/\.(glb\gltf)$/i)).map(item => item.Key);
  //const fileExtension = model.name.split('.')[1];

  // Helper function to generate URLs
  const getUrlForKey = (key) => `${baseCloudFrontUrl}/${key}`;

  const handlePrev = () => {
    setCurrentIdx((prevIdx) => (prevIdx - 1 + props.previewItems.length) % props.previewItems.length);
  };

  const handleNext = () => {
    setCurrentIdx((prevIdx) => (prevIdx + 1) % props.previewItems.length);
  };

  const handlePreviewClick = (index) => {
    setCurrentIdx(index);
  };

  const switchViewer = (newViewer) => {
    setModelviewerSelected(newViewer);
    if (newViewer == SelectedViewer.ThreeD) {
      setYawAngle(15);
      setPitchAngle(75);
    }
  };

  //Commented out temporarily to hide 360 icon
  // useEffect(() => {
  //   if (modelviewerSelected === SelectedViewer.ThreeSixty && !isShow360SpinIcon) {
  //     setTimeout(() => {
  //       setIsShow360SpinIcon(true)
  //     }, timeBeforeShowingSpinIcon);
  //   }
  // }, [modelviewerSelected])

  const changePicToShow = (image) => {
    //Set viewer to a specific image and set autoplay to false
    setPicToShow(image);
    switchViewer(SelectedViewer.TwoD);
  }

  const change360View = (pointOfView) => {
    //Set viewer to a specific image and set autoplay to false
    //Need tags on images or convention that it's always 36 images and we use image 0, 9, 18 and 27
    //Need a top view
    setIsAutoplay(false);
    console.log('POV:', pointOfView);
    switch (pointOfView) {
      case PointOfView.Front:
      default:
        setImageToShow(productSettings.is180Pan ? Math.round(productSettings.react360ImagesCount / 2) : 0); // Front view is half-way through the pan for a 180 pan
        setToggleImage((prev) => !prev);
        break;
      case PointOfView.Right:
        setImageToShow(productSettings.is180Pan ? 0 : productSettings.react360ImagesCount / 4);
        setToggleImage((prev) => !prev);
        break;
      case PointOfView.Back:
        setImageToShow(productSettings.react360ImagesCount / 2);
        setToggleImage((prev) => !prev);
        break;
      case PointOfView.Left:
        setImageToShow(productSettings.is180Pan ? productSettings.react360ImagesCount - 1 : 3 * productSettings.react360ImagesCount / 4);
        setToggleImage((prev) => !prev);
        break;

    }

    switchViewer(SelectedViewer.ThreeSixty);
  };

  useEffect(() => {
    //Need to force update when we click on the same point of view twice in a row
    //Run it in useEffect to avoid out of sync rendering issues
    setForceUpdate((prev) => !prev);
  }, [toggleImage])

  const changeCamView = (pointOfView) => {
    //Set viewer to a specific image and set autoplay to false
    //Need tags on images or convention that it's always 36 images and we use image 0, 9, 18 and 27
    //Need a top view
    switch (pointOfView) {
      case PointOfView.Front:
      default:
        setYawAngle(0);
        setPitchAngle(90);
        break;
      case PointOfView.Left:
        setYawAngle(90);
        setPitchAngle(90);
        break;
      case PointOfView.Back:
        setYawAngle(180);
        setPitchAngle(90);
        break;
      case PointOfView.Right:
        setYawAngle(270);
        setPitchAngle(90);
        break;
    }
  };

  const handleZoomClick = (currentImage) => {
    setIsAutoplay(false);
    //Extract the image index from the full url
    const regex = /\/(\d+)\.jpg/;
    const match = currentImage.match(regex);
    const currentImageIndex = match[1];
    console.log("Current image index:", currentImageIndex);
    setImageToShow(currentImageIndex - 1);
  }

  const getViewPointImg = async (viewPoint, valueToGet) => {
    const newValue = await valueToGet;
    return { viewPoint, newValue };
  };

  const handleResize = () => {
    document.body.style.display = "none";
    requestAnimationFrame(() => {
      document.body.style.display = "";
      const width = window.innerWidth;
      setWindowWidth(width);
    })
  };


  const getSignedUrl = async (productFolder, objectType, objectToFind = PointOfView.Front) => {
    //const currentData = await s3Ref.current.listObjectsV2(s3Params).promise();

    //const baseCloudFrontUrl = `https://${props.productS3BucketUrl}/${props.productFolder}/`;

    try {
      const currentData = await listObjectsInBucket(bucketName, productFolder);

      let cloudFrontUrls = [];

      if (objectType === ObjectType.Image) {
        const tempImg = currentData.Contents
          .filter(item => item.Key.match(new RegExp(`${objectToFind}\.(jpg|jpeg|png|gif)$`, 'i')))
          .map(item => item.Key);
        console.log("Processing image:", tempImg);
        return tempImg.map(item => getUrlForKey(item));
      }
      else if (objectType === ObjectType.ModelGlb) {
        //Ignore _uncompressed here
        const tempModel = currentData.Contents
          .filter(item => item.Key.match(/\.(glb|gltf)$/i) && !item.Key.match(/_uncompressed\.(glb|gltf)$/i))
          .map(item => item.Key);
        console.log("Glb model:", tempModel);
        return tempModel.map(item => getUrlForKey(item));
      }
      else if (objectType === ObjectType.ModelGlbU) {
        const tempModel = currentData.Contents
          .filter(item => item.Key.match(/_uncompressed\.(glb|gltf)$/i))
          .map(item => item.Key);
        console.log("GlbU model:", tempModel);
        return tempModel.map(item => getUrlForKey(item));
      }
      else if (objectType === ObjectType.ModelUsd) {
        const tempModel = currentData.Contents
          .filter(item => item.Key.match(/\.(usd|usdz)$/i))
          .map(item => item.Key);
        console.log("Usd model:", tempModel);
        return tempModel.map(item => getUrlForKey(item));
      }
      else if (objectType === ObjectType.ModelHdr) {
        const tempModel = currentData.Contents
          .filter(item => item.Key.match(/\.(hdr)$/i) && !item.Key.match(/_env\.(hdr)$/i))
          .map(item => item.Key);
        console.log("Hdr model:", tempModel);
        return tempModel.map(item => getUrlForKey(item));
      }
      else if (objectType === ObjectType.EnvironmentHdr) {
        const tempModel = currentData.Contents
          .filter(item => item.Key.match(/_env\.(hdr|exr)$/i))
          .map(item => item.Key);
        console.log("Hdr environment:", tempModel);
        return tempModel.map(item => getUrlForKey(item));
      }
      return cloudFrontUrls;
    } catch (error) {
      console.error("Error listing S3 objects: ", error);
      return [];
    }
  }


  const fetchFiles = async (productFolder) => {
    // const params = {
    //   Bucket: props.productS3BucketUrl,
    //   Prefix: productFolder
    // };


    const currentData = await listObjectsInBucket(bucketName, productFolder);
    //const currentData = await s3Ref.current.listObjectsV2(params).promise();
    //const response = await fetch(`https://s3.eu-west-2.amazonaws.com/${params.Bucket}?prefix=${params.Prefix}`);
    //const currentData = await response.json();

    console.log("Searching through:", productFolder);

    const imageKeys360 = currentData.Contents
      .filter(item => {
        const regex = new RegExp(`${productFolder}/\\d+_full+\\.(jpg|jpeg|png|gif)$`, 'i');
        return regex.test(item.Key);
      })
      .sort((a, b) => {
        const numA = parseInt(a.Key.split('/')[1].split('_')[0], 10);
        const numB = parseInt(b.Key.split('/')[1].split('_')[0], 10);
        return numA - numB;
      })
      .map(item => item.Key);

    if (!imageKeys360.length) {
      const imageKeys360 = currentData.Contents
        .filter(item => {
          const regex = new RegExp(`${productFolder}/\\d+\\.(jpg|jpeg|png|gif)$`, 'i');
          return regex.test(item.Key);
        })
        .sort((a, b) => {
          const numA = parseInt(a.Key.split('/')[1].split('_')[0], 10);
          const numB = parseInt(b.Key.split('/')[1].split('_')[0], 10);
          return numA - numB;
        })
        .map(item => item.Key);
    }

    const images360Urls = imageKeys360.map(item => getUrlForKey(item));

    console.log('images360Urls length:', images360Urls.length);
    let aspectRatio360 = 1;
    let aspectRatioProduct = 1;
    let aspectRatioTop = 1;

    //We don't get anything processed here
    if (images360Urls && images360Urls.length > 0) {
      const img = new Image();
      img.src = images360Urls[0];

      await new Promise(resolve => {
        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          aspectRatio360 = width / height;
          setIs360Present(true);
          resolve();
        };
      });
    }
    setIsAspectRatio360Calculated(true);

    // Create a regex pattern to match files we want to exclude, i.e. we only want files that have letters and don't include _front, _right, etc.
    const exclusionPattern = new RegExp(`(_(${Object.values(PointOfView).join('|')}))\\.(jpg|jpeg|png|gif)$`, 'i');
    const inclusionPattern = /\.(jpg|jpeg|png|gif)$/i;
    const numberPattern = /\/\d+\.(jpg|jpeg|png|gif)$/i;
    const numberFullRes = '_full';

    //console.log('currentData contents 2:', currentData);

    const imageKeys = currentData.Contents
      .filter(item =>
        !item.Key.match(exclusionPattern) &&
        item.Key.match(inclusionPattern) &&
        !item.Key.match(numberPattern) &&
        !item.Key.match(numberFullRes)
      )
      .map(item => item.Key);

    //console.log("image keys:", imageKeys);

    const productImagesMap = new Map();
    const fileExtensions = ['.jpg', 'jpeg', '.png', '.gif'];

    imageKeys.forEach(async (url) => {

      const isThumbnail = url.includes('_thumbnail');
      //This is failing
      const extension = fileExtensions.find(ext => url.endsWith(ext));

      if (!extension) {
        return;
      }

      //Get the root name of the image
      const baseName = isThumbnail ?
        url.replace(`_thumbnail${extension}`, '') :
        url.replace(extension, '');

      if (!productImagesMap.has(baseName)) {
        productImagesMap.set(baseName, { ...productImageTemplate });
      }
      //Get #_high pictures and put them in an array

      const productImage = productImagesMap.get(baseName);
      console.log('Image:', productImage);

      let isRatioProductSet = false;

      if (isThumbnail) {
        productImage.thumbnail = getUrlForKey(url);
      }
      else {
        productImage.image = getUrlForKey(url);
        if (!isRatioProductSet && !productImage.image.includes('_top.jpg')) {
          const img = new Image();
          img.src = productImage.image;

          await new Promise(resolve => {
            img.onload = () => {
              const width = img.naturalWidth;
              const height = img.naturalHeight;
              aspectRatioProduct = width / height;
              isRatioProductSet = true;
              console.log('RATIO PRODUCT:', aspectRatioProduct);
              setIsProductPresent(true);
              resolve();
            }
          });
        }
        else {
          const img = new Image();
          img.src = productImage.image;
          const topImage = img.src.includes('_top.jpg');
          if (topImage) {
            await new Promise(resolve => {
              img.onload = () => {
                const width = img.naturalWidth;
                const height = img.naturalHeight;
                aspectRatioTop = width / height;
                setIsTopPresent(true);
                console.log('RATIO TOP:', aspectRatioTop);
              }
            });
          }
        }
      }

    });
    setIsAspectRatioTopCalculated(true);
    setIsAspectRatioProductCalculated(true);

    const productImages = Array.from(productImagesMap.values());
    console.log('productImages:', productImages);

    const modelGlb = await getSignedUrl(productFolder, ObjectType.ModelGlb);
    const modelGlbU = await getSignedUrl(productFolder, ObjectType.ModelGlbU);
    const modelUsd = await getSignedUrl(productFolder, ObjectType.ModelUsd);
    const modelHdrs = await getSignedUrl(productFolder, ObjectType.ModelHdr);
    const environmentHdrs = await getSignedUrl(productFolder, ObjectType.EnvironmentHdr);
    const picToShow = await getSignedUrl(productFolder, ObjectType.Image, PointOfView.Front);

    //Recover json file here and parse json into a string to pass it on to ModelViewer as uniqueProductSettings
    const jsonConfigFile = currentData.Contents.find((item) => item.Key.endsWith('config.json'));
    const jsonDimensionsFile = currentData.Contents.find((item) => item.Key.endsWith('dimensions.json'));

    const s3 = new AWS.S3();
    let productSettings = JSON.parse(props.productSettings);

    const getJsonStringFromBucket = async (jsonFile) => {
      const params = {
        Bucket: bucketName,
        Key: jsonFile.Key,
      };
      const jsonFileData = await s3.getObject(params).promise();

      const jsonString = jsonFileData.Body.toString('utf-8');
      return JSON.parse(jsonString);
    }

    if (jsonConfigFile) {
      const modelViewerConfig = await getJsonStringFromBucket(jsonConfigFile);

      const mergedConfig = {
        ...productSettings, // Base settings
        ...modelViewerConfig // Overrides from viewerConfig
      };

      productSettings = mergedConfig;
    }

    if (jsonDimensionsFile) {
      const modelDimensions = await getJsonStringFromBucket(jsonDimensionsFile);

      setObjectDimensions(modelDimensions);
      console.log('model dimensions:', modelDimensions);

    }

    console.log('image 360:', images360Urls);
    console.log('product images:', productImages);
    //Getting promise here and not what we want
    console.log('modelGlb:', modelGlb);
    console.log('modelGlb uncompressed:', modelGlbU);
    console.log('modelUsd:', modelUsd);
    console.log('modelHdrs:', modelHdrs);
    console.log('environmentHdrs:', environmentHdrs);
    console.log('picToShow:', picToShow);
    console.log('aspect ratios:', aspectRatio360, aspectRatioTop, aspectRatioProduct);

    return {
      images360: images360Urls,
      aspectRatio360,
      productImages,
      aspectRatioProduct,
      aspectRatioTop,
      modelGlb,
      modelGlbU,
      modelUsd,
      modelHdrs: modelHdrs,
      environmentHdrs: environmentHdrs,
      picToShow,
      productSettings,
    };
  }


  const fetchAllFiles = async () => {
    //We use props.productFolder as the first load
    const baseSkuDataPromise = fetchFiles(props.productFolder);
    console.log("product variants:", props.productVariants);
    //Variants has changed from just a single sku to a struct, where we get an sku field
    const variantDataPromises = props.productVariants.map(item => fetchFiles(item.sku ? item.sku : item));
    //Do we need to use Promise here?
    const [baseSkuDataResult, ...variantDataResults] = await Promise.all([baseSkuDataPromise, ...variantDataPromises]);

    console.log('product folder:', props.productFolder);
    console.log('baseSkuDataResult:', baseSkuDataResult);
    //const variantDataResults = await Promise.all(variantDataPromises);

    const newVariantDataMap = new Map();
    newVariantDataMap.set(props.productFolder, baseSkuDataResult);
    props.productVariants.forEach((item, index) => {
      const skuName = item.sku ? item.sku : item;
      newVariantDataMap.set(skuName, variantDataResults[index]);
      console.log('Variant to load:', item, variantDataResults[index]);
    });

    setVariantDataMap(newVariantDataMap);
    //When we change the drop-down selection, the whole component re-renders and re-import assets. That's not happening on localhost though.
    //Might be because we set setLoading to true
    setIsFilesLoaded(true);
    //Force model viewer reinitialisation after loading product settings
    setModelViewerInitialised(false);
  }

  const setTriggerAR = (triggerFn) => {
    triggerAREvent.current = triggerFn;
    console.log('trigger function:', triggerFn);
  };

  const triggerAR = () => {
    if (triggerAREvent.current) {
      console.log('main trigger ar');
      triggerAREvent.current();
    }
    else {
      console.error('triggerAR is not defined in Carousel');
    }
  }

  useEffect(() => {
    // Don't switch model viewer after first load
    if (modelViewerInitialised) return;

    //We now need to concatenate productSettings and modelViewerConfig once the latter has been downloaded
    // Get the product settings after parsing the JSON
    const settings = productSettings;

    // Define the keys to check
    const keys = ['ModelViewer', 'ThreeSixtyViewer', 'Lifestyle'];

    // Try to find the first key with a value of 1
    let selectedKey = null;
    for (let key of keys) {
      if (settings[key] === 1) {
        selectedKey = key;
        break;
      }
    }

    // If no key with value 1 is found, select the key with the lowest value
    if (!selectedKey) {
      const lowestValueKey = keys.reduce((acc, key) => {
        return settings[key] < settings[acc] ? key : acc;
      }, keys[0]); // Start with the first key as the "lowest" by default

      selectedKey = lowestValueKey;
    }

    //Need a check here to prevent from switching if we've set this up previously
    // Update the selected viewer based on the selected key
    switch (selectedKey) {
      case 'ModelViewer':
        setModelviewerSelected(SelectedViewer.ThreeD);
        break;
      case 'ThreeSixtyViewer':
        setModelviewerSelected(SelectedViewer.ThreeSixty);
        break;
      case 'Lifestyle':
        setModelviewerSelected(SelectedViewer.TwoD);
        setPicToShow(productImages[0].image);
        break;
      default:
        setModelviewerSelected(SelectedViewer.ThreeSixty); // Fallback if no match is found
    }
    setModelViewerInitialised(true);
  }, [productSettings]);

  useEffect(() => {
    if (!isFilesLoaded) {
      fetchAllFiles();
    }

    let resizeTimeout;

    const handleResizeDebounced = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        handleResize();
      }, 200); // 200ms delay to ensure correct values
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize)
    return () => {
      clearTimeout(resizeTimeout);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [isFilesLoaded]);


  useEffect(() => {
    const rootElement = document.getElementById(props.rootDiv);
    if (!rootElement) return;

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        setViewerSize({ width, height });
      }
    });

    resizeObserver.observe(rootElement);

    return () => resizeObserver.disconnect(); // Cleanup on unmount
  }, [props.rootDiv]);

  useEffect(() => {
    console.log('Selected viewer:', modelviewerSelected);
  }, [modelviewerSelected]);

  useEffect(() => {
    if (isFilesLoaded) {
      const currentData = variantDataMap.get(props.productFolder);
      console.log('CURRENT DATA, DATA MAP:', currentData, variantDataMap);
      if (!currentData) return;
      setImages360(currentData.images360);

      const fetchImages = async () => {
        const frontImage = getViewPointImg(PointOfView.Front, getSignedUrl(props.productFolder, ObjectType.Image, PointOfView.Front));
        const leftImage = getViewPointImg(PointOfView.Left, getSignedUrl(props.productFolder, ObjectType.Image, PointOfView.Left));
        const backImage = getViewPointImg(PointOfView.Back, getSignedUrl(props.productFolder, ObjectType.Image, PointOfView.Back));
        const rightImage = getViewPointImg(PointOfView.Right, getSignedUrl(props.productFolder, ObjectType.Image, PointOfView.Right));

        const results = await Promise.all([frontImage, leftImage, backImage, rightImage]);

        const newViewpointImages = results.reduce((acc, { viewPoint, newValue }) => {
          acc[viewPoint] = newValue;
          return acc;
        }, {});

        setViewpointImages(newViewpointImages);
      };

      fetchImages();

      console.log('Model to load:', currentData.modelGlb);
      console.log('new product images:', currentData.productImages);
      setModelGlb(currentData.modelGlb);
      setModelGlbU(currentData.modelGlbU)
      setModelUsd(currentData.modelUsd);
      console.log('setting model hdrs to:', currentData.modelHdrs);
      setModelHdrs(currentData.modelHdrs);
      setEnvironmentHdrs(currentData.environmentHdrs);
      setProductSettings(currentData.productSettings);
      setWindowMargin(currentData.productSettings.windowMargin);
      setViewerMarginLeft(currentData.productSettings.viewerMarginLeft);
      setWidthSwitchToFullScreen(currentData.productSettings.switchToFullScreen !== undefined ? currentData.productSettings.switchToFullScreen : 980);
      setMaxViewerWidth(currentData.productSettings.maxViewerWidth !== undefined ? currentData.productSettings.maxViewerWidth : 1100);
      setViewerMargin(currentData.productSettings.viewerMargin !== undefined ? currentData.productSettings.viewerMargin : 30);
      setModelViewerMargin(currentData.productSettings.modelViewerMargin !== undefined ? currentData.productSettings.modelViewerMargin : 25);

      //Reset to 360 viewer if we're looking at product pictures to avoid issues
      if (modelviewerSelected === SelectedViewer.TwoD && currentData.picToShow[0]) {
        setIsAutoplay(true);
        switchViewer(SelectedViewer.ThreeSixty);
      }
      setPicToShow(currentData.picToShow[0] ? currentData.picToShow[0] : currentData.productImages[0].image);
      console.log('Pic to show:', currentData.picToShow[0]);
      setProductImages(currentData.productImages);
      setAspectRatio360(currentData.aspectRatio360);
      setAspectRatioTop(currentData.aspectRatioTop);
      setAspectRatioProduct(currentData.aspectRatioProduct);
    }
  }, [isFilesLoaded, props.productFolder]);


  //Call that each time mainProductViewerRef updates
  useEffect(() => {
    // Function to update the mainProductViewer's dimensions
    const element = mainProductViewerRef.current;
    if (!element) return;

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        setMainProductViewerWidth(width);
        setMainProductViewerHeight(height);
        console.log('Resized to:', width, height);
      }
    });

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };

  }, [aspectRatio360, window.innerWidth, viewerSize, mainProductViewerRef.current]);



  //Pb: this is called twice: once when we change productImages and once again when we change viewpointImages
  //Need to trigger Preview to re-render when viewpointImages is updated
  useEffect(() => {
    //This works fine the first time round, but then we need to clear viewpointImages when we update props.productFolder
    if ((images360.length > 0 && viewpointImages[PointOfView.Right] != "") || (productImages.length > 0 && images360.length == 0)) {
      setIsButtonsReady(true);
      //We're rendering buttons too quickly, before viewpointImages is ready
      console.log('viewpointimages:', viewpointImages);
      console.log('product images:', productImages);
    }
  }, [images360, productImages, viewpointImages]);

  // useEffect(() => {
  //   window.addEventListener(`resize`, handleResize);
  //   // Clean up the event listener when the component unmounts
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, [isFilesLoaded]);

  useEffect(() => {
    if (!isFilesLoaded) return;
    //If you don't pass additionalButtonsMaxSize that is matching a css setting, it won't size properly
    const buttonsMaxSize = productSettings.additionalButtonsMaxSize ? productSettings.additionalButtonsMaxSize : 200;
    //The reference buttons size for scaling is 200px
    setButtonsDivSize(Math.min((viewerSize.width - windowMargin), 1000 * buttonsMaxSize / 200) / (1000 * buttonsMaxSize / 200) * buttonsMaxSize);
  }, [viewerSize, isFilesLoaded, productSettings.additionalButtonsMaxSize]);

  useEffect(() => {
    console.log('buttons div size:', buttonsDivSize);
  }, [buttonsDivSize]);

  const userAgent = navigator.userAgent || window.opera;
  const isMobileDevice = /Mobi|Android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
    || (/android/i.test(userAgent));
  const verticalLayout = productSettings.orientation === 'vertical' && !isMobileDevice;

  const maxAspectRatio = ((ratioTop, ratioProduct, ratio360) => {
    return isTopPresent ? Math.max(aspectRatioTop, isProductPresent ? aspectRatioProduct : 0, is360Present ? aspectRatio360 : 0) :
      isProductPresent ? Math.max(aspectRatioProduct, is360Present ? aspectRatio360 : 0) : is360Present ? aspectRatio360 : 1;
  })

  useEffect(() => {
    // Spinner options
    const spinnerOptions = {
      lines: 12, // The number of lines to draw
      length: 0, // The length of each line
      width: 5, // The line thickness
      radius: 10, // The radius of the inner circle
      scale: 4, // Scales overall size
      corners: 1, // Corner roundness (0..1)
      color: '#000', // CSS color or array of colors
      fadeColor: 'transparent', // CSS color or array of colors
      speed: 1, // Rounds per second
      rotate: 0, // The rotation offset
      animation: 'spinner-line-fade-quick', // The CSS animation name
      direction: 1, // 1: clockwise, -1: counterclockwise
      zIndex: 2e9, // The z-index (defaults to 2000000000)
      className: 'spinner', // CSS class to assign to the spinner
      top: '50%', // Top position relative to parent
      left: '50%', // Left position relative to parent
      shadow: '0 0 1px transparent', // Box-shadow for the lines
      position: 'absolute', // Element positioning
    };

    // Create a Spinner instance
    const spinner = new Spinner(spinnerOptions);
    spinnerInstanceRef.current = spinner;

    // Mount spinner to the container
    if (spinnerContainerRef.current) {
      spinner.spin(spinnerContainerRef.current);
    }

    // Cleanup on component unmount
    return () => {
      if (spinnerInstanceRef.current) {
        spinnerInstanceRef.current.stop();
      }
    };
  }, [spinnerContainerRef.current]);

  {/* TODO: Refactor code for better method than using bool */ }

  //Delay rendering of App until we've calculated the aspect ratio of the picture
  //Pass image aspect ratio here
  /*  setProductImages(currentData.productImages); */
  /*

  Change position of buttons to be to the left of viewer if orientation is vertical
   */

  console.log('aspectRatioTop:', aspectRatioTop, 'aspectRatioProduct', aspectRatioProduct, '360:', aspectRatio360);
  console.log('window width:', window.innerWidth);
  console.log('margin:', productSettings.windowMargin);
  console.log('verticalLayout:', verticalLayout);
  console.log('product settings orientation:', productSettings.orientation);
  console.log('PRODUCT VIEWER MARGIN:', modelViewerMargin);
  console.log('mainProductViewerHeight:', mainProductViewerHeight);
  console.log('PIC TO SHOW:', picToShow);
  console.log('viewer margin left:', viewerMarginLeft);

  console.log('Product settings:', productSettings);

  //Force viewer to a certain value (e.g. 500px width) at startup, then set viewerSize

  return (
    <div
      ref={mainProductViewerRef}
      className={`mainProductViewer ${verticalLayout ? 'verticalLayout' : ''}`}
      style={{
        //1190
        //With this implementation, the height varies when the aspect ratio top, product and 360 are different
        //To avoid that, you would need to constraint the height to the max aspect ratio, then scale down width and height for other aspect ratios
        //Why is the aspect ratio not kept?
        // Note that window.visualViewport can be smaller than window.innerWidth on mobile
        //TODO: Update width and height based on container size and now window.innerWidth => container has to use the available space as a flex container
        //mainProductViewer has to scale based on the size of that container. Stop using 60% of the window. Use full width in shopify mode.
        //TODO: Handle switching from portrait to landscape on mobile
        // width: Math.min((((window.visualViewport.width || window.innerWidth) > mobileWidthThreshold) || 
        // (window.visualViewport?.width || window.innerWidth) >= (widthSwitchToFullScreen - windowMargin)) ? 0.6 * (window.visualViewport?.width || window.innerWidth) : 
        // Math.min((window.visualViewport?.width || window.innerWidth) - windowMargin, (widthSwitchToFullScreen - windowMargin - 1)), 
        // maxViewerWidth),
        // height: (1 / (Math.max(maxAspectRatio(aspectRatioTop, aspectRatioProduct, aspectRatio360)) ))
        // * Math.min(((((window.visualViewport.width || window.innerWidth) > mobileWidthThreshold) || 
        // (window.visualViewport?.width || window.innerWidth) >= (widthSwitchToFullScreen - windowMargin)) ? 0.6 * (window.visualViewport?.width || window.innerWidth) : 
        // Math.min((window.visualViewport?.width || window.innerWidth) - windowMargin, (widthSwitchToFullScreen - windowMargin - 1))), 
        // (maxViewerWidth)) - (verticalLayout ? buttonsDivSize : 0) + (verticalLayout ? 0 : buttonsDivSize) + viewerMargin,
        // marginRight: (window.visualViewport.width || window.innerWidth) > mobileWidthThreshold || 
        // (window.visualViewport?.width || window.innerWidth) >= (widthSwitchToFullScreen - windowMargin) ? viewerMargin : 0,
        // marginBottom:  (window.visualViewport.width || window.innerWidth) > mobileWidthThreshold || 
        // (window.visualViewport?.width || window.innerWidth) >= (widthSwitchToFullScreen - windowMargin) ? 0 : viewerMargin
        width: Math.min(((viewerSize.width > mobileWidthThreshold) || viewerSize.width >= widthSwitchToFullScreen) ?
          viewerSize.width - windowMargin : Math.min(viewerSize.width - windowMargin, widthSwitchToFullScreen - 1), maxViewerWidth),
        height: (1 / (Math.max(maxAspectRatio(aspectRatioTop, aspectRatioProduct, aspectRatio360))))
          * Math.min((((viewerSize.width > mobileWidthThreshold) || viewerSize.width >= widthSwitchToFullScreen) ? viewerSize.width - windowMargin :
            Math.min(viewerSize.width - windowMargin, (widthSwitchToFullScreen - 1))),
            (maxViewerWidth)) - (verticalLayout ? buttonsDivSize : 0) + (verticalLayout ? 0 : buttonsDivSize),
        marginRight: viewerSize.width > mobileWidthThreshold || viewerSize.width >= widthSwitchToFullScreen ? viewerMargin : 0,
        marginBottom: viewerSize.width > mobileWidthThreshold || viewerSize.width >= widthSwitchToFullScreen ? 0 : viewerMargin
      }}
    >
      {!isAspectRatio360Calculated || !isAspectRatioTopCalculated || !isAspectRatioProductCalculated ?
        null
        : modelviewerSelected === SelectedViewer.ThreeD ? (
          isFilesLoaded ? (
            <>
              {/* <div className="model-viewer-3D" style={{ marginBottom: '25px' }}> */}
              <div
                className="model-viewer-container"
                style={{
                  marginBottom: verticalLayout ? '0' : modelViewerMargin,
                  marginLeft: verticalLayout ? viewerMarginLeft : '0',
                  width: verticalLayout ? mainProductViewerWidth - buttonsDivSize : mainProductViewerWidth,
                  height: verticalLayout ? mainProductViewerHeight : mainProductViewerHeight - buttonsDivSize
                }}
              >
                {/* TODO: add prop so we can set the camera angle */}
                <Suspense fallback={<div>Loading...</div>}>
                  <ModelViewer
                    onSetLoading={props.onSetLoading}
                    variantFileGlb={modelGlb}
                    variantFileGlbUncompressed={modelGlbU}
                    variantFileUsd={modelUsd}
                    variantFilesHdr={modelHdrs}
                    variantEnvironmentsHdr={environmentHdrs}
                    yawAngle={yawAngle}
                    pitchAngle={pitchAngle}
                    windowWidth={window.innerWidth}
                    windowHeight={window.innerHeight}
                    aspectRatio={aspectRatio360}
                    objectDimensions={objectDimensions}
                    productTags={props.productTags}
                    modelType={props.modelType}
                    productSettings={productSettings}
                    configuratorEnabled={props.configuratorEnabled}
                    onMeshClicked={props.onMeshClicked}
                    setCamTransform={setCamTransform}
                    camTransform={camTransform}
                    parentWidth={(verticalLayout ? mainProductViewerWidth - buttonsDivSize : mainProductViewerWidth) - viewerMarginLeft}
                    parentHeight={(verticalLayout ? mainProductViewerHeight - viewerMargin : mainProductViewerHeight - buttonsDivSize - viewerMargin) - viewerMarginLeft}
                    style={{
                      width: verticalLayout ? mainProductViewerWidth - buttonsDivSize : mainProductViewerWidth,
                      height: verticalLayout ? mainProductViewerHeight : mainProductViewerHeight - buttonsDivSize,
                      marginLeft: viewerMarginLeft
                    }}
                    onTriggerAR={triggerAR}
                  />
                </Suspense>
                {/* Pass on button click event */}
                {/* <Carousel 
            onSetLoading={props.onSetLoading} 
            variantFileGlb={modelGlb} 
            variantFileUsd={modelUsd} 
            yawAngle={yawAngle} 
            pitchAngle={pitchAngle} 
            windowWidth={window.innerWidth}
            aspectRatio={aspectRatio360}
            parentWidth={productSettings.orientation === 'vertical' ? 0.8 * mainProductViewerWidth : mainProductViewerWidth} 
            parentHeight={productSettings.orientation === 'vertical' ? mainProductViewerHeight : 0.8 * mainProductViewerHeight}
            setTriggerAR={setTriggerAR}
            /> */}
              </div>
            </>) : (null)
        ) : modelviewerSelected === SelectedViewer.ThreeSixty ? (
          isFilesLoaded ? (
            <div className={`viewer360 ${verticalLayout ? 'verticalLayout' : ''}`}>
              <img
                className={`icon-360-spin`}
                src={`${window.ASSET_BASE_URL || process.env.PUBLIC_URL}/360spinicon.png`}
                style={{
                  display: isShow360SpinIcon ? "block" : "none",
                  left: 0.46 * mainProductViewerWidth,
                  width: 0.1 * mainProductViewerWidth,
                  height: 0.1 * mainProductViewerWidth,
                }}
              ></img>
              <Suspense fallback={<div>Loading...</div>}>
                <ProductViewerComponent
                  productsS3Bucketname={props.productS3BucketUrl}
                  productFolder={props.productFolder}
                  cloudFrontUrl={props.cloudFrontUrl}
                  autoplayViewer={isAutoPlay && props.isAutoPlay}
                  imageToShow={imageToShow}
                  forceUpdate={forceUpdate}
                  images360HD={images360}
                  onClickZoom={(handleZoomClick)}
                  productSettings={productSettings}
                  windowWidth={window.innerWidth}
                  aspectRatio={aspectRatio360}
                  //Keep product viewer in the right aspect ratio
                  parentWidth={(verticalLayout ? mainProductViewerWidth - buttonsDivSize : mainProductViewerWidth) - viewerMarginLeft}
                  parentHeight={(verticalLayout ? mainProductViewerHeight - viewerMargin : mainProductViewerHeight - buttonsDivSize - viewerMargin) - viewerMarginLeft}
                  onPointerMoved={() => { setIsShow360SpinIcon(false); }}
                  showRotationIconOnStartup={productSettings.showRotationIconOnStartup}
                  imagesCount={productSettings.react360ImagesCount}
                  is180Pan={productSettings.is180Pan}
                />
              </Suspense>
            </div>) :
            (
              <div className="viewer360Loader"
                style={{
                  width: verticalLayout ? mainProductViewerWidth - buttonsDivSize : mainProductViewerWidth,
                  height: mainProductViewerHeight - buttonsDivSize,
                  position: 'relative',
                }}>
                <div
                  ref={spinnerContainerRef}
                  style={{
                    width: verticalLayout ? mainProductViewerWidth - buttonsDivSize : mainProductViewerWidth,
                    height: mainProductViewerHeight - buttonsDivSize,
                  }}
                ></div>
                {/* <Player
              autoplay
              loop
              src={`${process.env.PUBLIC_URL}/lottie_loading_pill.json`}
              style={{ height: mainProductViewerWidth, width: mainProductViewerHeight }}
              /> */}
              </div>)
        ) : (
          isFilesLoaded ? (
            <>
              <div
                className={`growmProductImage ${verticalLayout ? 'verticalLayout' : ''}`}
                style={{
                  width: verticalLayout ? mainProductViewerWidth - buttonsDivSize : mainProductViewerWidth,
                  height: verticalLayout ? mainProductViewerHeight - viewerMargin : mainProductViewerHeight - buttonsDivSize - viewerMargin,
                }}
              >
                {picToShow && picToShow.includes('_top.jpg') ? (
                  <Suspense fallback={<div>Loading...</div>}>
                    <InnerImageZoom
                      src={picToShow}
                      // zoomSrc={currentHDImageUrl}
                      zoomType="click"
                      fullscreenOnMobile={true}
                      hasSpacer={true}
                      alt='Front'
                      width={(verticalLayout ? mainProductViewerWidth - buttonsDivSize : mainProductViewerWidth) - viewerMarginLeft}
                      height={(verticalLayout ? mainProductViewerHeight - viewerMargin : mainProductViewerHeight - buttonsDivSize - viewerMargin) - viewerMarginLeft}
                      style={{
                        marginLeft: viewerMarginLeft
                      }}
                    />
                  </Suspense>
                ) : (
                  <img
                    className="iiz__img"
                    src={picToShow}
                    width={(verticalLayout ? mainProductViewerWidth - buttonsDivSize : mainProductViewerWidth) - viewerMarginLeft}
                    height={(verticalLayout ? mainProductViewerHeight - viewerMargin : mainProductViewerHeight - buttonsDivSize - viewerMargin) - viewerMarginLeft}
                    style={{
                      marginLeft: viewerMarginLeft
                    }}
                  />
                )}
              </div>
            </>
          ) : (null)
        )
      }
      <div className={`otherbuttonssection ${verticalLayout ? 'verticalLayout' : ''}`}>
        {isButtonsReady && props.showAdditionalButtons ? (
          <Suspense fallback={<div>Loading...</div>}>
            <Preview
              onPrevClick={handlePrev}
              onNextClick={handleNext}
              onChangeView={change360View}
              onSwitch3DViewer={switchViewer}
              OnChangePicture={changePicToShow}
              PreviewItems={modelGlb}
              onHandlePreviewClick={handlePreviewClick}
              viewpointImages={viewpointImages}
              productImages={productImages}
              currentIdx={currentIdx}
              is180Pan={productSettings.is180Pan}
              windowWidth={window.innerWidth}
              productSettings={productSettings}
              parentWidth={mainProductViewerWidth}
              parentHeight={mainProductViewerHeight - viewerMargin}
              buttonsDivSize={buttonsDivSize}
            />
          </Suspense>
        ) : <></>}
      </div>
    </div>
  );
};

export default Main;